export enum DisputeEditModesEnum {
  CREATE_DISPUTE = 'CREATE DISPUTE',
  VIEW_DISPUTE = 'VIEW DISPUTE',
  // VIEW_DISPUTE_FOR_GRAB = 'VIEW DISPUTE FOR GRAB',
  EDIT_DISPUTE = 'EDIT',
  // APPROVAL_DISPUTE = 'APPROVAL DISPUTE',
}
